import { createStore } from 'vuex';
import legoPieces from './lego_pieces';

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    lego_pieces: legoPieces,
  },
});
